export const GET_COMPONENTS_SUCCESS = 'GET_COMPONENTSS_SUCCESS';
export const GET_COMPONENTS_FAILURE = 'GET_COMPONENTS_FAILURE';
export const GET_COMPONENTS = 'GET_COMPONENTS';
